"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRelatedInstructionMessage = void 0;
var _enums = require("../enums");
var getRelatedInstructionMessage = exports.getRelatedInstructionMessage = function getRelatedInstructionMessage(relatedEntity, messages, isChecklist) {
  var length = relatedEntity.length;
  if (length === 0) {
    return isChecklist ? messages.relatedChecklists : messages.relatedInstructions;
  }
  if (length === 1) {
    var entity = relatedEntity[0];
    var isEntityChecklist = entity.type === _enums.INSTRUCTION_TYPE.CHECKLIST;
    return isEntityChecklist ? messages.relatedChecklists : messages.relatedInstructions;
  }
  if (length === 2) {
    var isEntity1Checklist = relatedEntity[0].type === _enums.INSTRUCTION_TYPE.CHECKLIST;
    var isEntity2Checklist = relatedEntity[1].type === _enums.INSTRUCTION_TYPE.CHECKLIST;
    if (isEntity1Checklist && isEntity2Checklist) {
      return messages.relatedChecklists;
    } else if (!isEntity1Checklist && !isEntity2Checklist) {
      return messages.relatedInstructions;
    } else {
      return messages.relatedInstructionAndChecklist;
    }
  }
};
//# sourceMappingURL=related-instructions-utils.js.map